import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

import { NoResultsProps } from './NoResults.types'

export const NoResults = (props: NoResultsProps) => {
  const { className } = props

  return (
    <Row
      className={clsx('align-items-center justify-content-center', className)}
      style={{
        height: '100%',
      }}
    >
      <Col className="text-center" sm="auto" xs="auto">
        <p className="text-secondary my-0">
          <FormattedMessage id="No_results" />
        </p>
      </Col>
    </Row>
  )
}
